import './style.scss';
import React, { Component } from 'react';
import { Animated } from 'react-animated-css';
import { Draggable } from '../Draggable';
import { Resizable } from '../Resizable';
import { Rotateable } from '../Rotateable';
import { Deleteable } from '../Deleteable';

export const withStickerOverlay = (Component) => {
  return class extends Component {
    constructor(props) {
      super(props);
      this.onUpdatePosition = this.onUpdatePosition.bind(this);
      this.onUpdateSize = this.onUpdateSize.bind(this);
      this.onUpdateAngle = this.onUpdateAngle.bind(this);
      this.onDelete = this.onDelete.bind(this);
    }

    onUpdatePosition(sticker, { top: topInPx, left: leftInPx }) {
      const { onUpdateSticker, size = {} } = this.props;
      const { height, width } = size;

      onUpdateSticker &&
        onUpdateSticker({
          ...sticker,
          position: {
            x: leftInPx.split('px')[0] / width,
            y: topInPx.split('px')[0] / height,
          },
        });
    }

    onUpdateSize(sticker, { height: heightInPx, width: widthInPx }) {
      const { onUpdateSticker, size = {} } = this.props;
      const { height, width } = size;

      onUpdateSticker &&
        onUpdateSticker({
          ...sticker,
          size: {
            height: heightInPx.split('px')[0] / height,
            width: widthInPx.split('px')[0] / width,
          },
        });
    }

    onUpdateAngle(sticker, angle) {
      const { onUpdateSticker } = this.props;
      onUpdateSticker &&
        onUpdateSticker({
          ...sticker,
          rotate: angle,
        });
    }

    onDelete(sticker) {
      const { onDeleteSticker } = this.props;
      onDeleteSticker && onDeleteSticker(sticker);
    }

    render() {
      const { stickers = [], size = {}, editMode = false } = this.props;
      const { height, width, offsetX = 0, offsetY = 0 } = size;
      return (
        <div className={'sticker-overlay'} style={{ height: `100%`, width: `100%` }}>
          <Component {...this.props} ref={this.ref} />

          {stickers.map((sticker) => {
            const stickerImage = (
              <Animated animateOnMount={false} animationIn={sticker.animate.in} animationOut={sticker.animate.out} isVisible={sticker.visible}>
                <img
                  className={'sticker-image'}
                  src={sticker.url}
                  style={{
                    height: `${sticker.size.height * (height - offsetY)}px`,
                    width: `${sticker.size.width * (width - offsetX)}px`,
                    transform: `rotate(${editMode ? 0 : sticker.rotate}deg)`,
                  }}
                />
              </Animated>
            );

            const top = sticker.position.y * (height - offsetY) + offsetY / 2;
            const left = sticker.position.x * (width - offsetX) + offsetX / 2;

            if (editMode) {
              return (
                <Draggable key={sticker.id} top={top} left={left} onDragEnd={this.onUpdatePosition.bind(this, sticker)}>
                  <Rotateable sticker={sticker} isEditable={sticker.visible} onRotate={this.onUpdateAngle.bind(this, sticker)}>
                    <Deleteable onDelete={this.onDelete.bind(this, sticker)}>
                      <Resizable isEditable={sticker.visible} onResize={this.onUpdateSize.bind(this, sticker)}>
                        <div className={`sticker-container editable ${!sticker.visible && 'hide'}`}>
                          <Animated animateOnMount={false} animationIn={sticker.animate.in} animationOut={sticker.animate.out} isVisible={sticker.visible}>
                            {stickerImage}
                          </Animated>
                        </div>
                      </Resizable>
                    </Deleteable>
                  </Rotateable>
                </Draggable>
              );
            } else {
              return (
                <div className={'sticker-container'} style={{ position: 'absolute', top: `${top}px`, left: `${left}px` }}>
                  <Animated animateOnMount={false} animationIn={sticker.animate.in} animationOut={sticker.animate.out} isVisible={sticker.visible}>
                    {stickerImage}
                  </Animated>
                </div>
              );
            }
          })}
        </div>
      );
    }
  };
};
